/*
 * Sliderul de recenzii din sectiunea "Value props + video".
 * Videoul NU are nevoie de JS aici: foloseste <deferred-media>, elementul
 * definit global in global.js.
 *
 * Autonom fata de theme.Sections: se initializeaza singur si se reinitializeaza
 * la shopify:section:load, ca sa functioneze si in theme editor.
 */
(function () {
  var SELECTOR = '[data-value-props]';
  var instances = {};

  function destroy(id) {
    if (instances[id]) {
      instances[id].destroy(true, true);
      delete instances[id];
    }
  }

  function init(root) {
    if (!root) return;
    if (typeof window.Swiper === 'undefined') return;

    var id = root.dataset.sectionId;
    var slider = root.querySelector('.value-props__slider');
    if (!slider) return;

    var slides = slider.querySelectorAll('.swiper-slide');
    if (slides.length < 2) return;

    destroy(id);

    // Fara `autoHeight`: acea optiune animeaza inaltimea wrapper-ului
    // (`transition-property: transform, height`) si sectiunea saltaie cand
    // recenziile au lungimi diferite. Fara ea, wrapper-ul flex intinde toate
    // slide-urile la inaltimea celei mai lungi, deci inaltimea ramane fixa.
    instances[id] = new Swiper(slider, {
      loop: true,
      speed: 500,
      slidesPerView: 1,
      autoplay:
        root.dataset.autorotate === 'true'
          ? {
              delay: parseInt(root.dataset.autorotateDelay, 10) || 7000,
              disableOnInteraction: false,
            }
          : false,
      pagination: {
        el: root.querySelector('.value-props__pagination'),
        clickable: true,
      },
      navigation: {
        nextEl: root.querySelector('.value-props__next'),
      },
      a11y: {
        nextSlideMessage: 'Recenzia urmatoare',
      },
    });
  }

  function initWhenNear(root) {
    if (!('IntersectionObserver' in window)) return init(root);
    var observer = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      observer.disconnect();
      init(root);
    }, { rootMargin: '300px 0px' });
    observer.observe(root);
  }

  function initAll() {
    document.querySelectorAll(SELECTOR).forEach(initWhenNear);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector(SELECTOR);
    if (root) init(root);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector(SELECTOR);
    if (root) destroy(root.dataset.sectionId);
  });
})();
